import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, FormatCurrency } from 'day8-ui';
import PromoCode from '../PromoCode';

const PaymentPageToPay = ({
  booking, className
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const discountItems = booking.refactoredOrder.filter(item => item.price < 0);
  const isDealBooking = booking?.boatWeek?.isDeal === true;
  return (
    <div className={className}>
      <div className="dui-flex dui-items-center dui-gap-4">
        <div className="dui-flex dui-flex-col dui-items-start dui-gap-2">
          {/* Always offered, even when a discount is already on the booking: a referral code is a
              credit for whoever referred the guest, so it still needs to be enterable once an
              automatic promo has taken the discount slot. */}
          <Button buttonType={"LINK_UNDERLINE"} buttonSize='SMALL' onClick={() => setIsOpen(!isOpen)}>Have a promo or referral code?</Button>
        </div>
      </div>
      {isOpen && !isDealBooking && (
        <div className="dui-mt-4">
          <PromoCode booking={booking} />
        </div>
      )}
      {discountItems.length > 0 && (
        <div className="dui-mt-4 dui-bg-primary-100 dui-p-4">
          <h3 className="dui-text-xl">Discounts applied</h3>
          <div>
            {booking.refactoredOrder.filter(item => item.price < 0).map(item => (
              <div key={item.label} className='dui-mt-4 dui-flex dui-justify-between dui-items-center'>
                <p>{item.label}</p>
                <span className="dui-font-semibold"><FormatCurrency amount={item.price} baseCurrency={item.currency} /></span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
PaymentPageToPay.propTypes = {
  booking: PropTypes.object.isRequired
};
export default PaymentPageToPay;
